import React from "react";
import PropTypes from "prop-types";
import { Box, Paper, Typography } from "@material-ui/core";
import { BRAND } from "src/theme/brandTokens";

/**
 * Sección narrativa del contenido de una propuesta V2 en la vista admin.
 * Espejo visual del PDF: título en acento naranja, borde inferior del título
 * como acento, cuerpo con `white-space: pre-wrap` para respetar saltos.
 *
 * Render nada si `value` es falsy — el orquestador no necesita condicionales.
 */
const SeccionNarrativa = ({ titulo, value, children, descripcionItalic }) => {
  const hasBody = value || children;
  if (!hasBody) return null;
  return (
    <Paper elevation={0} variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
      <Typography
        variant="h6"
        sx={{
          color: BRAND.color.primary,
          fontWeight: 700,
          borderBottom: `2px solid ${BRAND.color.primary}`,
          pb: 1,
          mb: 2,
        }}
      >
        {titulo}
      </Typography>
      {descripcionItalic && (
        <Typography
          variant="body1"
          sx={{
            fontStyle: "italic",
            color: "text.secondary",
            mb: 1.5,
          }}
        >
          {descripcionItalic}
        </Typography>
      )}
      {value && (
        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
          {value}
        </Typography>
      )}
      {children && <Box>{children}</Box>}
    </Paper>
  );
};

SeccionNarrativa.propTypes = {
  titulo: PropTypes.string.isRequired,
  value: PropTypes.string,
  children: PropTypes.node,
  descripcionItalic: PropTypes.string,
};

SeccionNarrativa.defaultProps = {
  value: undefined,
  children: undefined,
  descripcionItalic: undefined,
};

export default SeccionNarrativa;
